import { Plus, ChevronRight, Star, ChevronDown } from 'lucide-react';
import './styles/Department.css';

interface DepartmentHeaderProps {
  onAddDepartment: () => void;
}

const DepartmentHeader = ({ onAddDepartment }: DepartmentHeaderProps) => {
  return (
    <div className="department-header">
      <div className="department-header-left">
        <div className="department-title-row">
          <h1 className="department-title">Department</h1>

          <Star className="department-star" size={14} />
        </div>

        <div className="department-breadcrumb">
          <span className="breadcrumb-text">Master</span>

          <ChevronRight size={14} className="breadcrumb-arrow" />

          <span className="breadcrumb-text">Department</span>
        </div>

        <p className="department-description">Manage and configure your departments type</p>
      </div>

      <button className="add-department-btn" onClick={onAddDepartment}>
        <Plus className="add-btn-plus" />

        <span className="add-btn-text">Add Department</span>

        <div className="add-btn-divider" />

        <ChevronDown className="add-btn-arrow" />
      </button>
    </div>
  );
};

export default DepartmentHeader;
